import React, { useState } from 'react';
import { motion, Variants } from 'framer-motion';
import { useLandingTranslations } from '../contexts/LandingTranslationContext';
import ContactPopup from './ContactPopup';

const fadeInUp: Variants = {
  hidden: { opacity: 0, y: 60 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut" as const
    }
  }
};

const Services = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const { translations } = useLandingTranslations();

  return (
    <motion.section className="py-20 bg-white/70">
      <div className="container mx-auto px-8">
        <motion.h2 
          className="text-4xl font-bold text-center text-[#3D587D] mb-16"
          variants={fadeInUp}
          initial="hidden"
          whileInView="visible"
        >
          {translations.services.title}
        </motion.h2>
        <div className="grid md:grid-cols-3 gap-8">
          {translations.services.items.map((plan, index) => (
            <motion.div
              key={index}
              className={`p-8 rounded-xl flex flex-col ${
                plan.name === translations.services.items[1].name
                  ? 'bg-[#3D587D] text-white scale-105' 
                  : 'bg-white text-[#3D587D]'
              } shadow-xl`}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              whileHover={{ y: -10 }}
            >
              {plan.name === translations.services.items[1].name && (
                <div className="text-[#FFDB89] text-sm font-semibold mb-4">{translations.services.mostPopular}</div>
              )}
              <h3 className="text-2xl font-bold mb-4">{plan.name}</h3>
              <div className="mb-6">
                {'price' in plan && plan.price && <span className="text-4xl font-bold">{plan.price}</span>}
                {'period' in plan && plan.period && <span className={`text-sm ml-2 ${plan.period === "90 CAD" ? "line-through" : ""}`}>{plan.period}</span>}
              </div>
              <ul className="space-y-4 mb-8 flex-grow">
                {plan.features.map((feature, i) => (
                  <li key={i} className="flex items-center">
                    <span className="mr-2">✓</span>
                    {feature}
                  </li>
                ))}
              </ul>
              <motion.button
                className={`w-full py-3 rounded-full font-semibold ${
                  plan.name === translations.services.items[1].name
                    ? 'bg-[#FFDB89] text-[#3D587D]' 
                    : 'bg-[#3D587D] text-white'
                }`}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => setIsPopupOpen(true)}
              >
                {translations.services.getStarted}
              </motion.button>
            </motion.div>
          ))}
        </div>
      </div>

      <ContactPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
    </motion.section>
  );
};

export default Services; 